import DISPLAY_STATES from "./displayStates";
import {
  DISPLAY_STATE_ACTION,
  ADD_UPLOADS_ACTION,
  REMOVE_UPLOAD_ACTION,
  SET_CROP_ACTION,
  SET_COMPLETED_CROP_ACTION,
  SET_NEW_IMAGE_ACTION,
  RESET_NEW_IMAGE_ACTION,
} from "./uploadActions";

export const initialState = {
  displayState: DISPLAY_STATES.INITIAL,
  url: null,
  largeAvatarUrl: null,
  crop: {
    unit: "%",
    x: 25,
    y: 25,
    width: 50,
    height: 50,
  },
  completedCrop: {
    unit: "px",
    x: 25,
    y: 25,
    width: 160,
    height: 90,
  },
  newImage: null,
  newImageWidth: null,
  newImageHeight: null,
};

const uploadMultipleFilesReducer = (state = initialState, action) => {
  switch (action.type) {
    case DISPLAY_STATE_ACTION: {
      return { ...state, displayState: action.newState };
    }

    case ADD_UPLOADS_ACTION: {
      return {
        ...state,
        displayState: DISPLAY_STATES.HAS_UPLOAD,
        url: action.url,
        largeAvatarUrl: action.largeAvatarUrl,
      };
    }

    case REMOVE_UPLOAD_ACTION: {
      return {
        ...state,
        displayState: DISPLAY_STATES.INITIAL,
        url: null,
        largeAvatarUrl: null,
      };
    }

    case SET_CROP_ACTION: {
      return {
        ...state,
        crop: { ...state.crop, ...action.crop },
        ...(!!(action.newImageWidth && action.newImageHeight) && {
          newImageWidth: action.newImageWidth,
          newImageHeight: action.newImageHeight,
        }),
      };
    }

    case SET_COMPLETED_CROP_ACTION: {
      return {
        ...state,
        completedCrop: action.completedCrop,
      };
    }

    case SET_NEW_IMAGE_ACTION: {
      return { ...state, newImage: action.newImage };
    }

    case RESET_NEW_IMAGE_ACTION: {
      return {
        ...state,
        newImage: null,
        newImageWidth: null,
        newImageHeight: null,
        crop: {},
        completedCrop: {},
      };
    }

    default: {
      return state;
    }
  }
};

export default uploadMultipleFilesReducer;
